import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import axios from 'axios'

Vue.use(Router)
let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			props: true,
			component: () => import('./components/Common/appHome'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/Login',
			name: 'Login',
			props: true,
			component: () => import('./components/Common/appLogin'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/ForgotPassword',
			name: 'ForgotPassword',
			props: true,
			component: () => import('./components/Common/appForgotPassword'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '*',
			name: 'NotFound',
			props: true,
			component: () => import('./components/Common/404'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/ServerError',
			name: 'ServerError',
			props: true,
			component: () => import('./components/Common/500'),
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/Wishlist',
			name: 'Wishlist',
			component: () => import('./components/Wishlist/wishlist'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/Cart',
			name: 'Cart',
			component: () => import('./components/Cart/cart'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/MyOrders',
			name: 'MyOrders',
			component: () => import('./components/Orders/orders'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/MyOrders/:id',
			name: 'MyOrder',
			props: true,
			component: () => import('./components/Orders/order'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/BuyNow/:id',
			name: 'BuyNow',
			props: true,
			component: () => import('./components/BuyNow/buyNow'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/Payment/:id',
			name: 'Payment',
			props: true,
			component: () => import('./components/Payment/payment'),
			meta: {
				requiresAuth: true,
				isSeller: false,
			}
		},
		{
			path: '/Profile',
			name: 'Profile',
			component: () => import('./components/Account/profile'),
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/Products',
			name: 'Products',
			props: true,
			component: () => import('./components/Products/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/BestSellers',
			name: 'BestSellers',
			props: true,
			component: () => import('./components/BestSellers/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		
		// {
		// 	path: '/:Type/:Category/:id',
		// 	name: 'GeneralFilter',
		// 	props: true,
		// 	component: () => import('./components/GeneralFilter/product'),
		// 	meta: {
		// 		requiresAuth: false,
		// 		isSeller: false,
		// 	}
		// },
		{
			path: '/DailyEssentials/:type/:id/:name',
			name: 'DailyEssentials',
			props: true,
			component: () => import('./components/DailyEssentials/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/Groceries/:type/:id/:name',
			name: 'Groceries',
			props: true,
			component: () => import('./components/Groceries/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/Category/:id/:name',
			name: 'Category',
			props: true,
			component: () => import('./components/Category/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/SubCategory/:id/:name',
			name: 'SubCategory',
			props: true,
			component: () => import('./components/SubCategory/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/sellerRegistration',
			name: 'SellerRegistration',
			component: () => import('./components/Login/sellerRegistration'),
			meta: {
				requiresAuth: false,
				isSeller: true,
			}
		},
		{
			path: '/addProduct',
			name: 'addProduct',
			component: () => import('./components/Seller/Products/addProduct'),
			meta: {
				requiresAuth: true,
				isSeller: true
			}
		},
		{
			path: '/inventory',
			name: 'inventory',
			component: () => import('./components/Seller/Products/inventory'),
			meta: {
				requiresAuth: true,
				isSeller: true
			}
		},
		{
			path: '/myProducts',
			name: 'myProducts',
			component: () => import('./components/Seller/Products/myProducts'),
			meta: {
				requiresAuth: true,
				isSeller: true
			}
		},
		{
			path: '/Search/:searchKey',
			name: 'Search',
			props: true,
			component: () => import('./components/Search/products'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},
		{
			path: '/:id/:product',
			name: 'Product',
			props: true,
			component: () => import('./components/Product/product'),
			meta: {
				requiresAuth: false,
				isSeller: false,
			}
		},


	],
	scrollBehavior() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0;
	},
})
router.beforeEach((to, from, next) => {

	if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
		next({ name: 'Login', params: { lastPage: from } })
		return
	}
	if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
		axios({
			method: 'POST',
			url: '/validate/token',
			headers: {
				'x-auth-token': localStorage.getItem('token')
			}
		}).then(response => {
			if (!response.data.status) {
				store.commit("sessionOut", true)
				return
			}
		})
			.catch(err => {
				this.msg = err;
			});
	}
	if (to.name == 'Login' && store.state.isLoggedIn && (store.state.isSeller === 'false' || store.state.isSeller === false)) {
		next({ name: 'Home' })
		return
	} if (to.name == 'Login' && store.state.isLoggedIn && (store.state.isSeller === 'true' || store.state.isSeller === true)) {
		next({ name: 'myProducts' })
		return
	}
	if (to.matched.some(route => route.meta.isSeller) && store.state.isLoggedIn && (store.state.isSeller === 'false' || store.state.isSeller === false)) {
		next({ name: 'Home' })
		return
	}
	if (to.matched.some(route => !route.meta.isSeller) && store.state.isLoggedIn && (store.state.isSeller === 'true' || store.state.isSeller === true)) {
		next({ name: 'myProducts' })
		return
	}

	next()
})

export default router